import { useState, useEffect } from "react";
import { FaCalendarAlt } from 'react-icons/fa'; // Icons as needed
import SideNave from "../common/sidenav";
import TopNav from "../common/topnav";
import '../common/style.css';
import { useNavigate } from 'react-router-dom'; // Import useNavigate from react-router-dom

export default function SearchCandidateComponent() {
    const [isSidebarOpen, setIsSidebarOpen] = useState(
        localStorage.getItem('sb|sidebar-toggle') === 'true'
    );

    useEffect(() => {
        localStorage.setItem('sb|sidebar-toggle', isSidebarOpen);
    }, [isSidebarOpen]);

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
        localStorage.setItem('sb|sidebar-toggle', !isSidebarOpen);
    };

    const [formData, setFormData] = useState({
        startDate: '',
        endDate: '',
    });

    const [errorMessage, setErrorMessage] = useState('');

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const navigate = useNavigate();

    const handleSearch = (e) => {
        e.preventDefault();

        // Validation: Check if startDate and endDate are not empty
        if (!formData.startDate || !formData.endDate) {
            setErrorMessage('Start Date and End Date are required.');
            return;
        }

        // Validation: Check if startDate is less than endDate
        if (new Date(formData.startDate) >= new Date(formData.endDate)) {
            setErrorMessage('Start Date must be earlier than End Date.');
            return;
        }

        // Reset error message
        setErrorMessage('');

        // Navigate to the next component with query parameters
        navigate(`/export?startDate=${formData.startDate}&endDate=${formData.endDate}`);
    };

    return (
        <div className="SearchCandidateComponent">
            <div className={`sb-nav-fixed ${isSidebarOpen ? 'sb-sidenav-toggled' : ''}`}>
                <TopNav toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} />
                <div id="layoutSidenav">
                    <SideNave isSidebarOpen={isSidebarOpen} />
                    <div id="layoutSidenav_content">
                        <main>
                            <div className="container-fluid px-4">
                                <h4 className="mt-4">Search Candidate</h4>
                                <div className="card mb-4 shadow border-0">
                                    {errorMessage && (
                                        <div className="alert alert-danger">
                                            {errorMessage}
                                        </div>
                                    )}
                                    <div className="card-body">
                                        <form onSubmit={handleSearch}>
                                            <div className="mb-3">
                                                <label htmlFor="startDate" className="form-label">Start Date</label>
                                                <div className="input-group">
                                                    <span className="input-group-text"><FaCalendarAlt /></span>
                                                    <input
                                                        type="date"
                                                        className="form-control"
                                                        id="startDate"
                                                        name="startDate"
                                                        value={formData.startDate}
                                                        onChange={handleInputChange}
                                                        required
                                                    />
                                                </div>
                                            </div>

                                            <div className="mb-3">
                                                <label htmlFor="endDate" className="form-label">End Date</label>
                                                <div className="input-group">
                                                    <span className="input-group-text"><FaCalendarAlt /></span>
                                                    <input
                                                        type="date"
                                                        className="form-control"
                                                        id="endDate"
                                                        name="endDate"
                                                        value={formData.endDate}
                                                        onChange={handleInputChange}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <button type="submit" className="btn btn-primary btn-sm">Next >> </button>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </main>
                    </div>
                </div>
            </div>
        </div>
    );
}
